import Service from "../../AuthService";
const AdvancePayment = {
    getAdvancePayment(page) {
        return Service.get("/advance_payment?page="+page);
    },
    getOtherPayment(data) {
        return Service.get("/costemployeeother?page="+data.page+"&employee_id="+data.employee_id+"&date="+data.date+"&type="+data.type);
    },
    setOtherIncome(page) {
        return Service.get("/setOtherIncome?page="+page);
    },
    showAdvancePayment(id) {
        return Service.get("/advance_payment/" + id);
    },
    showAdvancePaymentDetails(id) {
        return Service.get("/advance_payment_details/" + id);
    },
    updateAdvancePayment(id, data) {
        return Service.put("/advance_payment/" + id, data);
    },
    createAdvancePayment(data) {
        return Service.post("/advance_payment", data);
    },
    deleteAdvancePayment(id) {
        return Service.delete("/advance_payment/" + id);
    },
    deleteOtherPayment(id) {
        return Service.delete("/costemployeeother/" + id);
    },
    destroyIncome(id) {
        return Service.get("/destroyIncome/" + id);
    },
    searchAdvancePayment(data){
        return Service.post('/advance_payment_search',data);
    },
    searchOtherPayment(data){
        return Service.post('/costemployeeother_search',data);
    },
    searchOtherIncome(data){
        return Service.post('/incomeemployeeother_search',data);
    }

};
export default AdvancePayment;
